//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//
// ProfileDefaults
// ---------------
// This object of type ProfileDto represents the default base values to use for a brand new eSIM profile, note that this
// is not intended to be a valid and complete profile, merely the initial structure from which the user works with.
//
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const ProfileDefaults: ProfileDto = {
  generalInformation: {
    tsaSpec_gte_2p3: null,
  },
  networkAuthentication: {
    authenticationAlgorithm: "1",
    tuakOptions: {
      resSize: null,
      macSize: null,
      ckikSize: null,
      numberOfKeccak: 1,
      keyLength: "1",
    },
    xorOptions: {
      resSize: "1",
      macSize: "1",
      ckikSize: "1",
    },
    mapUSIMandISIMforAKAparameters: "0",
    mapUSIMandISIMforAKAconfiguration: null,
    sqnOptions: {
      anonymityKey: null,
      sqnWrapAround: null,
      sqnDelta: null,
      sqnDeltaValue: "000010000000",
      sqnAgeLimit: null,
      sqnAgeLimitValue: "000010000000",
    },
  },
  suciEncryptionScheme: {
    suciCalculation: null,
    primaryEncryptionScheme: null,
    addSecondEncryptionScheme: null,
    secondEncryptionScheme: null,
    addRemainingEncryptionScheme: null,
    routingIndicator: '0',
  },
  isimConfiguration: {
    homeNetworkDomainName: null,
    inputFileContainsIMPIandIMPU: null,
    pcscfConfiguration: [],
    gbaUserAuthentication: null,
  },
  rfmConfiguration: [],
  ramConfiguration: {
    tarList: {
      tars: [],
      selectedTars: null,
    },
    mslValue: null,
    integrityCheckOption: null,
    cipheringOption: null,
    counterOption: null,
  },
  adminAgent: {
    configureAdminAgent: null,
    commandDetails: ["014003"],
    deviceIdentities: "8182",
    alphaIdOpenChannel: null,
    bearerDescription: "03",
    bufferSize: 1422,
    networkAccessName: null,
    userLogin: null,
    userPassword: null,
    transportProtocolType: { value: "02" },
    portNumber: 80,
    dataDestinationType: "1",
    dataDestinationAddress: {
      ipv4: {
        address1: 0,
        address2: 0,
        address3: 0,
        address4: 0,
      },
      ipv6: {
        address1: "0000",
        address2: "0000",
        address3: "0000",
        address4: "0000",
        address5: "0000",
        address6: "0000",
        address7: "0000",
        address8: "0000",
      },
    },
    pskIdentity: null,
    keyVersion: "40",
    keyIdentifier: "01",
    retryCounter: 1,
    retryHours: 0,
    retryMinutes: 0,
    retrySeconds: 43,
    administrationHostParameters: null,
    agentIdParameter: null,
    administrationURIParameter: null,
  },
  otaKeysVisited: false,
  otaKeys: {
    scp80: {
      keyVersionNumber: "01",
      klc: {
        keyIdentifier: "01",
        keyType: "2",
        keyDataSize: "1",
        keyDataValue: null,
        keyDataValueGeneration: "1",
        isDerived: false
      },
      kid: {
        keyIdentifier: "02",
        keyType: "2",
        keyDataSize: "1",
        keyDataValue: null,
        keyDataValueGeneration: "1",
        isDerived: false
      },
      dek: {
        keyIdentifier: "03",
        keyType: "2",
        keyDataSize: "1",
        keyDataValue: null,
        keyDataValueGeneration: "1",
        isDerived: false
      },
    },
    scp81: {
      keyVersionNumber: "40",
      psk: {
        keyIdentifier: "01",
        keyType: "3",
        keyDataSize: "1",
        keyDataValue: null,
        keyDataValueGeneration: "1",
        isDerived: false
      },
      dek: {
        keyIdentifier: "02",
        keyType: "2",
        keyDataSize: "1",
        keyDataValue: null,
        keyDataValueGeneration: "1",
        isDerived: false
      },
    },
  },
  pinsVisited: false,
  pins: [
    {
      id: 1,
      type: "1",
      number: "1",
      size: 4,
      value: null,
      valueGeneration: "1",
      attributes: {
        stateChange: "1",
        pinChange: "1",
        pinEnabled: "2",
      },
      maxAttempts: 10,
      retryNumberLeft: 10,
      hasPuk: true,
      puk: {
        size: 8,
        value: null,
        valueGeneration: "1",
        maxAttempts: 10,
        retryNumberLeft: 10,
      },
    },
    {
      id: 2,
      type: "3",
      number: "1",
      size: 8,
      value: null,
      valueGeneration: "1",
      hasPuk: false,
    },
  ],
  javaAppletsVisited: false,
  javaApplets: [],
  m2mConnectivityParameters: {
    m2mRemoteProvisioningSystem: null,
    protocol: null,
    smsCenterAddress: null,
    networkAccessName: null,
    priority: null,
  },
  directoryFileVisited: false,
  directoryFiles: [],
  networkNameVisited: false,
  networkNames: [
    {
      recordNumber: 1,
      fullName: null,
    },
    {
      recordNumber: 2,
      fullName: null,
    },
    {
      recordNumber: 3,
      fullName: null,
    },
    {
      recordNumber: 4,
      fullName: null,
    },
    {
      recordNumber: 5,
      fullName: null,
    },
    {
      recordNumber: 6,
      fullName: null,
    },
    {
      recordNumber: 7,
      fullName: null,
    },
    {
      recordNumber: 8,
      fullName: null,
    },
    {
      recordNumber: 9,
      fullName: null,
    },
    {
      recordNumber: 10,
      fullName: null,
    },
  ],
  plmnInformationVisited: false,
  plmnInformation: [
    {
      recordNumber: 1,
      mobileCountryCode: null,
      mobileNetworkCode: null,
      pnnRecordId: null,
    },
    {
      recordNumber: 2,
      mobileCountryCode: null,
      mobileNetworkCode: null,
      pnnRecordId: null,
    },
    {
      recordNumber: 3,
      mobileCountryCode: null,
      mobileNetworkCode: null,
      pnnRecordId: null,
    },
    {
      recordNumber: 4,
      mobileCountryCode: null,
      mobileNetworkCode: null,
      pnnRecordId: null,
    },
    {
      recordNumber: 5,
      mobileCountryCode: null,
      mobileNetworkCode: null,
      pnnRecordId: null,
    },
  ],
  homePLMNwithAcT: [
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
  ],
  oPLMNwithAcT: [
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
      accessTechnology: null,
    },
  ],
  useEquivalentHomePLMN: null,
  equivalentHomePLMN: [
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
    },
    {
      mobileCountryCode: null,
      mobileNetworkCode: null,
    },
  ],
  lastRegisteredPLMN: null,
  higherPriorityPLMN: {
    supported: null,
    searchPeriod: { label: $localize`72 hours`, value: "36" },
  },
  smsParameters: [
    {
      id: 1,
      name: null,
      parameterIndicators: [
        { label: $localize`Service Center Address`, value: "2" },
        { label: $localize`Protocol Identifier`, value: "3" },
        { label: $localize`Data Coding Scheme`, value: "4" },
      ],
      destinationAddress: null,
      serviceCenterAddress: null,
      protocolIdentifier: "00",
      dataCodingScheme: { label: $localize`(04) 8bit data`, value: "2" },
      validityPeriod: null,
    },
  ],
  groupIdentifiers: {
    useGroupIdentifiers: null,
    gid1: null,
    gid2: null,
  },
  emergencyCallCodes: [],
  regulatoryECallSupport: {
    supportECall: null,
    eCallType: null,
    eCallOnlyRecords: [
      {
        recordNumber: 1,
        displayName: $localize`Test Number`,
        dialingNumber: null,
      },
      {
        recordNumber: 2,
        displayName: $localize`Reconfiguration Number`,
        dialingNumber: null,
      },
    ],
    eCallAndNormalRecords: [
      {
        recordNumber: 9,
        displayName: $localize`Test Number`,
        dialingNumber: null,
      },
      {
        recordNumber: 10,
        displayName: $localize`Reconfiguration Number`,
        dialingNumber: null,
      },
    ],
  },
  languagesVisited: false,
  languages: {
    language1: { value: "en" },
    language2: { value: "" },
    language3: { value: "" },
  },
  usimServiceTableVisited: false,
  usimServiceTable: {
    usimService1: false,
    usimService2: false,
    usimService3: false,
    usimService4: false,
    usimService5: false,
    usimService6: false,
    usimService7: false,
    usimService8: false,
    usimService9: false,
    usimService10: true,
    usimService11: true,
    usimService12: true,
    usimService13: false,
    usimService14: false,
    usimService15: false,
    usimService16: false,
    usimService17: false,
    usimService18: false,
    usimService19: true,
    usimService20: false,
    usimService21: true,
    usimService22: false,
    usimService23: false,
    usimService24: false,
    usimService25: false,
    usimService26: false,
    usimService27: false,
    usimService28: true,
    usimService29: false,
    usimService30: false,
    usimService31: false,
    usimService32: true,
    usimService33: true,
    usimService34: false,
    usimService35: false,
    usimService36: false,
    usimService37: false,
    usimService38: false,
    usimService39: false,
    usimService40: false,
    usimService41: false,
    usimService42: true,
    usimService43: true,
    usimService44: false,
    usimService45: true,
    usimService46: true,
    usimService47: false,
    usimService48: false,
    usimService49: false,
    usimService50: false,
    usimService51: false,
    usimService52: false,
    usimService53: false,
    usimService54: false,
    usimService55: false,
    usimService56: false,
    usimService57: false,
    usimService58: false,
    usimService59: false,
    usimService60: false,
    usimService61: false,
    usimService62: false,
    usimService63: false,
    usimService64: false,
    usimService65: false,
    usimService66: false,
    usimService67: false,
    usimService68: false,
    usimService69: false,
    usimService70: false,
    usimService71: false,
    usimService72: false,
    usimService73: true,
    usimService74: true,
    usimService75: false,
    usimService76: false,
    usimService77: false,
    usimService78: false,
    usimService79: false,
    usimService80: false,
    usimService81: false,
    usimService82: false,
    usimService83: false,
    usimService84: false,
    usimService85: true,
    usimService86: false,
    usimService87: false,
    usimService88: false,
    usimService89: false,
    usimService90: false,
    usimService91: true,
    usimService92: false,
    usimService93: false,
    usimService94: false,
    usimService95: false,
    usimService96: true,
    usimService97: false,
    usimService98: false,
    usimService99: false,
    usimService100: false,
    usimService101: false,
    usimService102: false,
    usimService103: false,
    usimService104: false,
    usimService105: false,
    usimService106: false,
    usimService107: false,
    usimService108: false,
    usimService109: false,
    usimService110: false,
    usimService111: false,
    usimService112: false,
    usimService113: false,
    usimService114: false,
    usimService115: false,
    usimService116: false,
    usimService117: false,
    usimService118: false,
    usimService119: false,
    usimService120: false,
    usimService121: false,
    usimService122: false,
    usimService123: false,
    usimService124: false,
    usimService125: false,
    usimService126: false,
    usimService127: false,
    usimService128: false,
    usimService129: false,
    usimService130: false,
    usimService131: false,
  },
  isimServiceTableVisited: false,
  isimServiceTable: {
    isimService1: true,
    isimService2: false,
    isimService3: false,
    isimService4: false,
    isimService5: false,
    isimService6: false,
    isimService7: false,
    isimService8: false,
    isimService9: false,
    isimService10: false,
    isimService11: false,
    isimService12: false,
    isimService13: false,
    isimService14: false,
    isimService15: false,
    isimService16: false,
    isimService17: false,
    isimService18: false,
    isimService19: false,
    isimService20: false,
    isimService21: false,
  },
};

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//
// All of the interfaces below this point define the type structure of a ProfileDto object.
//
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export interface ProfileDto {
  generalInformation: {
    tsaSpec_gte_2p3: string | null; // String with numeric value; 1 = TSA spec < 2.3, 2 = TSA spec >= 2.3
  };
  networkAuthentication: {
    authenticationAlgorithm: string | null; // String with numeric value; 1 = Milenage, 2 = Tuak, 3 = XOR
    tuakOptions: {
      resSize: string | null; // String with numeric value; 1 = 32 bits, 2 = 64 bits, 3 = 128 bits, 4 = 256 bits
      macSize: string | null; // String with numeric value; 1 = 64 bits, 2 = 128 bits, 3 = 256 bits
      ckikSize: string | null; // String with numeric value; 1 = 128 bits, 2 = 256 bits
      numberOfKeccak: number | null; // 1-1600
      keyLength: string | null; // String with numeric value; 1 = 16 bits, 2 = 32 bits
    };
    xorOptions: {
      resSize: string | null; // String with numeric value; 1 = 32 bits, 2 = 64 bits, 3 = 128 bits
      macSize: string | null; // String with numeric value; 1 = 64 bits
      ckikSize: string | null; // String with numeric value; 1 = 128 bits
    };
    mapUSIMandISIMforAKAparameters: string | null; // String with numeric value; 1 = Yes, 0 = No
    mapUSIMandISIMforAKAconfiguration: string | null; // String with numeric value; 1 = Do not share SQL parameters/values, 2 = Share sqnInit, sqnOptions, sqnDelta, sqnAgeLimit, 3 = Share sqnOptions, sqnDelta, sqnAgeLimit, 4 = Share sqnOptions, sqnDelta, sqnAgeLimit, and SQN array
    sqnOptions: {
      anonymityKey: string | null; // String with numeric value; 0 = Not used, 1 = Used
      sqnWrapAround: string | null; // String with numeric value; 0 = Not allowed, 1 = Allowed
      sqnDelta: string | null; // String with numeric value; 0 = Not used, 1 = Used
      sqnDeltaValue: string | null; // Hex value for sqnDelta
      sqnAgeLimit: string | null; // String with numeric value; 0 = Not used, 1 = Used
      sqnAgeLimitValue: string | null; // Hex value for sqnAgeLimit
    };
  };
  suciEncryptionScheme: {
    suciCalculation: string | null; // String with numeric value; 1 = Mobile, 2 = USIM, 3 = Other
    primaryEncryptionScheme: string | null; // String with numeric value; 1 = Null, 2 = ECIES Profile A, 3 = ECIES Profile B
    addSecondEncryptionScheme: string | null; // String with numeric value; 1 = Yes, 0 = No
    secondEncryptionScheme: string | null; // String with numeric value; 1 = Null, 2 = ECIES Profile A, 3 = ECIES Profile B
    addRemainingEncryptionScheme: string | null; // String with numeric value; 1 = Yes, 0 = No
    routingIndicator: string | null; // String 1-4 characters long containing only numbers
  };
  isimConfiguration: {
    homeNetworkDomainName: string | null; // String value for the home network domain name
    inputFileContainsIMPIandIMPU: string | null; // String with numeric value; 1 = Yes, 0 = No
    pcscfConfiguration: PCSCFConfigurationDto[] | null; // See PCSCFConfigurationDto
    gbaUserAuthentication: string | null; // String with numeric value; 1 = Yes, 0 = No
  };
  rfmConfiguration: RFMConfigurationDto[] | null; // See RFMConfigurationDto
  ramConfiguration: RAMConfigurationDto | null; // See RAMConfigurationDto
  adminAgent: {
    configureAdminAgent: string | null; // String with numeric value; Only used by the GUI for workflow direction; 1 = Yes, 0 = No
    commandDetails: string[] | null; // An array of 3 byte hex values
    deviceIdentities: string | null; // 2 byte hex value
    alphaIdOpenChannel: string | null; // 0 to 255 character string
    bearerDescription: string | null; // 1 byte hex value
    bufferSize: number | null; // 0 < value <= 65535
    networkAccessName: string | null; // 0 to 255 character string
    userLogin: string | null; // 0 to 255 character string
    userPassword: string | null; // 0 to 255 character string
    transportProtocolType: DropDownDto | null; // Value property of DropDownDto is 1 byte hex value
    portNumber: number | null; // 0 < value <= 65535
    dataDestinationType: string | null; // String with numeric value; 1 = IPv4, 2 = IPv6, 3 = none
    dataDestinationAddress: {
      ipv4: {
        address1: number | null; // 0 <= value <= 255
        address2: number | null; // 0 <= value <= 255
        address3: number | null; // 0 <= value <= 255
        address4: number | null; // 0 <= value <= 255
      };
      ipv6: {
        address1: string | null; // 2 byte hex value
        address2: string | null; // 2 byte hex value
        address3: string | null; // 2 byte hex value
        address4: string | null; // 2 byte hex value
        address5: string | null; // 2 byte hex value
        address6: string | null; // 2 byte hex value
        address7: string | null; // 2 byte hex value
        address8: string | null; // 2 byte hex value
      };
    };
    pskIdentity: string | null; // String value of user supplied PSK
    keyVersion: string | null; // 1 byte hex value
    keyIdentifier: string | null; // 1 byte hex value
    retryCounter: number | null; // 0 to 9999 numerical value
    retryHours: number | null; // 0 to 99 numerical value
    retryMinutes: number | null; // 0 to 99 numerical value
    retrySeconds: number | null; // 0 to 99 numerical value
    administrationHostParameters: string | null; // 0 to 255 character string
    agentIdParameter: string | null; // String value of user supplied Agent ID Parameter
    administrationURIParameter: string | null; // 0 to 255 character string
  };
  otaKeysVisited: boolean; // GUI workflow item to determine whether section has been seen, since it passes validation by default we only want to denote it as checked when it has at least been visited
  otaKeys: {
    scp80: {
      keyVersionNumber: string | null; // 1 byte hex value,
      klc: {
        keyIdentifier: string | null; // 1 byte hex value
        keyType: string | null; // String with numeric value; 1 = 80 (DES), 2 = 88 (AES)
        keyDataSize: string | null; // String with numeric value; 1 = 16, 2 = 24, 3 = 32
        keyDataValue: string | null; // Hex value that is "keyDataSize" bytes long
        keyDataValueGeneration: string | null; // String with numeric value; 1 = eDGAR Generated, 2 = User Defined
        isDerived: boolean | null;
      };
      kid: {
        keyIdentifier: string | null; // 1 byte hex value
        keyType: string | null; // String with numeric value; 1 = 80 (DES), 2 = 88 (AES)
        keyDataSize: string | null; // String with numeric value; 1 = 16, 2 = 24, 3 = 32
        keyDataValue: string | null; // Hex value that is "keyDataSize" bytes long
        keyDataValueGeneration: string | null; // String with numeric value; 1 = eDGAR Generated, 2 = User Defined
        isDerived: boolean | null;
      };
      dek: {
        keyIdentifier: string | null; // 1 byte hex value
        keyType: string | null; // String with numeric value; 1 = 80 (DES), 2 = 88 (AES)
        keyDataSize: string | null; // String with numeric value; 1 = 16, 2 = 24, 3 = 32
        keyDataValue: string | null; // Hex value that is "keyDataSize" bytes long
        keyDataValueGeneration: string | null; // String with numeric value; 1 = eDGAR Generated, 2 = User Defined
        isDerived: boolean | null;
      };
    };
    scp81: {
      keyVersionNumber: string | null; // 1 byte hex value,
      psk: {
        keyIdentifier: string | null; // 1 byte hex value
        keyType: string | null; // String with numeric value; 3 = 85 (PSK for TLS)
        keyDataSize: string | null; // String with numeric value; 1 = 16, 2 = 24, 3 = 32
        keyDataValue: string | null; // Hex value that is "keyDataSize" bytes long
        keyDataValueGeneration: string | null; // String with numeric value; 1 = eDGAR Generated, 2 = User Defined
        isDerived: boolean | null;
      };
      dek: {
        keyIdentifier: string | null; // 1 byte hex value
        keyType: string | null; // String with numeric value; 1 = 80 (DES), 2 = 88 (AES)
        keyDataSize: string | null; // String with numeric value; 1 = 16, 2 = 24, 3 = 32
        keyDataValue: string | null; // Hex value that is "keyDataSize" bytes long
        keyDataValueGeneration: string | null; // String with numeric value; 1 = eDGAR Generated, 2 = User Defined
        isDerived: boolean | null;
      };
    };
  };
  pinsVisited: boolean; // GUI workflow item to determine whether section has been seen, since it passes validation by default we only want to denote it as checked when it has at least been visited
  pins: PinDto[] | null;
  javaAppletsVisited: boolean; // GUI workflow item to determine whether section has been seen, since it passes validation by default we only want to denote it as checked when it has at least been visited
  javaApplets: JavaAppletsDto[] | null;
  m2mConnectivityParameters: {
    m2mRemoteProvisioningSystem: string | null; // String with numeric value; 1 = Yes, 0 = No
    protocol: string | null; // String with numeric value; 1 = SMS, 2 = HTTP, 3 = Both SMS + HTTP
    smsCenterAddress: string | null; // A string value with a max length of 20 characters
    networkAccessName: string | null; // A string value with a max length of 20 characters
    priority: string | null; // String with numeric value; (Only valid if protocol = 3) 1 = SMS, 2 = HTTP
  };
  directoryFileVisited: boolean; // GUI workflow item to determine whether section has been seen, since it passes validation by default we only want to denote it as checked when it has at least been visited
  directoryFiles: DirectoryFilesDto[] | null; // See DirectoryFilesDto
  networkNameVisited: boolean; // GUI workflow item to determine whether section has been seen, since it passes validation by default we only want to denote it as checked when it has at least been visited
  networkNames: NetworkNameDto[] | null; // See NetworkNameDto
  plmnInformationVisited: boolean; // GUI workflow item to determine whether section has been seen, since it passes validation by default we only want to denote it as checked when it has at least been visited
  plmnInformation: PLMNInformationDto[] | null; // See PLMNInformationDto
  homePLMNwithAcT: PLMNWithAcTDto[] | null; // See PLMNWithAcTDto
  oPLMNwithAcT: PLMNWithAcTDto[] | null; // See PLMNWithAcTDto
  useEquivalentHomePLMN: string | null; // String with numeric value; 1 = Yes, 0 = No
  equivalentHomePLMN: PLMNWithoutAcTDto[] | null; // See PLMNWithoutAcTDto
  lastRegisteredPLMN: string | null; // String with numeric value; 1 = Last Registered PLMN, 2 = Home PLMN
  higherPriorityPLMN: {
    supported: string | null; // String with numeric value; 1 = Yes, 0 = No
    searchPeriod: DropDownDto | null; // Value property of DropDownDto is a number ranging from 0 to 80
  };
  smsParameters: SMSParametersDto[] | null; // See SMSParametersDto
  groupIdentifiers: {
    useGroupIdentifiers: string | null; // String with numeric value; 1 = Yes, 0 = No
    gid1: string | null; // 8 byte hex value
    gid2: string | null; // 8 byte hex value
  };
  emergencyCallCodes: EmergencyCallCodesDto[] | null; // See EmergencyCallCodesDto
  regulatoryECallSupport: {
    supportECall: string | null; // String with numeric value; 1 = Yes, 0 = No
    eCallType: string | null; // String with numeric value; 1 = eCall Only, 2 = ecall + Normal
    eCallOnlyRecords: ECallRecordsDto[] | null; // See ECallRecordsDto; Array of records specific to eCallType 1 selection
    eCallAndNormalRecords: ECallRecordsDto[] | null; // See ECallRecordsDto; Array of records specific to eCallType 2 selection
  };
  languagesVisited: boolean; // GUI workflow item to determine whether section has been seen, since it passes validation by default we only want to denote it as checked when it has at least been visited
  languages: {
    language1: DropDownDto | null; // Value property of DropDownDto is 2 character string value for ISO-639-1 country code (or empty string for no selection)
    language2: DropDownDto | null; // Value property of DropDownDto is 2 character string value for ISO-639-1 country code (or empty string for no selection)
    language3: DropDownDto | null; // Value property of DropDownDto is 2 character string value for ISO-639-1 country code (or empty string for no selection)
  };
  usimServiceTableVisited: boolean; // GUI workflow item to determine whether section has been seen, since it passes validation by default we only want to denote it as checked when it has at least been visited
  usimServiceTable: USIMServiceTableDto | null; // USIMServiceTableDto
  isimServiceTableVisited: boolean; // GUI workflow item to determine whether section has been seen, since it passes validation by default we only want to denote it as checked when it has at least been visited
  isimServiceTable: ISIMServiceTableDto | null; // ISIMServiceTableDto
}

export interface DropDownDto {
  label?: string; // Only used by the GUI; User facing text at the time of selection
  value: string; // The value of the object which is of importance in its reference use
}

export interface MilenageParametersDto {
  opc: string | null; // Hex value for opc
  rotationConstant_r1: string | null; // Hex value for r1
  rotationConstant_r2: string | null; // Hex value for r2
  rotationConstant_r3: string | null; // Hex value for r3
  rotationConstant_r4: string | null; // Hex value for r4
  rotationConstant_r5: string | null; // Hex value for r5
  xoringConstant_c1: string | null; // Hex value for c1
  xoringConstant_c2: string | null; // Hex value for c2
  xoringConstant_c3: string | null; // Hex value for c3
  xoringConstant_c4: string | null; // Hex value for c4
  xoringConstant_c5: string | null; // Hex value for c5
}

export interface TuakParametersDto {
  topc: string | null; // Hex value for op
  keccakIterations: number | null; // Value for number of keccak iterations
}

export interface PCSCFConfigurationDto {
  id: number; // Used by the GUI to generate a unique key per record
  addressType: DropDownDto | null; // See DropDownDto; Value property: 1 = FQDN, 2 = IPv4, 3 = IPv6
  pcscfAddressFQDN: string | null; // String value for the P-CSCF address for FQDN addressType
  pcscfAddressIPv4: {
    // Values for the P-CSCF address for IPV4 addressType
    address1: number | null; // 0 <= value <= 255
    address2: number | null; // 0 <= value <= 255
    address3: number | null; // 0 <= value <= 255
    address4: number | null; // 0 <= value <= 255
  };
  pcscfAddressIPv6: {
    // Values for the P-CSCF address for IPV6 addressType
    address1: string | null; // 2 byte hex value
    address2: string | null; // 2 byte hex value
    address3: string | null; // 2 byte hex value
    address4: string | null; // 2 byte hex value
    address5: string | null; // 2 byte hex value
    address6: string | null; // 2 byte hex value
    address7: string | null; // 2 byte hex value
    address8: string | null; // 2 byte hex value
  };
}

export interface RFMConfigurationDto {
  id: number; // Used by the GUI to generate a unique key per record
  instanceAID: string | null; // 5 to 16 byte hex value
  tarList: TarListDto | null; // See TarListDto
  mslValue: string | null; // 1 byte hex value
  integrityCheckOption: string | null; // String with numeric value; Used by the GUI for expressing mslValue into option groups
  cipheringOption: string | null; // String with numeric value; Used by the GUI for expressing mslValue into option groups
  counterOption: string | null; // String with numeric value; Used by the GUI for expressing mslValue into option groups
  uiccAccessDomain: string | null; // 1 byte hex value
  uiccAccessDomainRadioValue: string | null; // String with numeric value; Used internally by the GUI for radio group quick selector
  uiccAdminAccessDomain: string | null; // 1 byte hex value
  uiccAdminAccessDomainRadioValue: string | null; // String with numeric value; Used internally by the GUI for radio group quick selector
  adfAID: string | null; // 5 to 16 byte hex value
  adfAccessDomain: string | null; // 1 byte hex value
  adfAccessDomainRadioValue: string | null; // String with numeric value; Used internally by the GUI for radio group quick selector
  adfAdminAccessDomain: string | null; // 1 byte hex value
  adfAdminAccessDomainRadioValue: string | null; // String with numeric value; Used internally by the GUI for radio group quick selector
}

export interface RAMConfigurationDto {
  tarList: TarListDto | null; // See TarListDto
  mslValue: string | null; // 1 byte hex value
  integrityCheckOption: string | null; // String with numeric value; Used by the GUI for expressing mslValue into option groups
  cipheringOption: string | null; // String with numeric value; Used by the GUI for expressing mslValue into option groups
  counterOption: string | null; // String with numeric value; Used by the GUI for expressing mslValue into option groups
}

export interface TarListDto {
  tars: TarsDto[] | null;
  selectedTars: any[] | null; // Used internally by the GUI for nested table functions
}

export interface TarsDto {
  tarId: number; // Used by the GUI to generate a unique key per record
  tarValue: string | null; // 3 byte hex value
}

export interface PinDto {
  id: number; // Used by the GUI to generate a unique key per record
  type: string | null; // String with numeric value; 1 = PIN, 2 = Local PIN, 3 = ADM
  number: string | null; // String with numeric value; Number of the pin, so if type = 3 and number = 4, this means "ADM4"
  size: number | null; // For non ADM pins a numerical value from 4 to 8, for ADM pins either 8 (for digits) or 16 (for HEX chars)
  value: string | null; // Actual pin value
  valueGeneration: string | null; // String with numeric value; 1 = eDGAR Generated, 2 = User Defined
  attributes?: {
    // "attributes" object is only defined for PinDto.type 1 and 2
    stateChange: string | null; // String with numeric value; 1 = Allowed, 2 = Not Allowed
    pinChange: string | null; // String with numeric value; 1 = Can be changed, 2 = Cannot be changed
    pinEnabled: string | null; // String with numeric value; 1 = Enabled, 2 = Disable
  };
  maxAttempts?: number | null; // Numerical value from 0 to 255 (property only defined for PinDto.type 1 and 2)
  retryNumberLeft?: number | null; // Numerical value from 0 to 255 (property only defined for PinDto.type 1 and 2)
  hasPuk: boolean; // Denotes whether this pin type contains a corresponding puk object
  puk?: {
    size: number | null; // Numerical value from 4 to 8
    value: string | null; // Actual pin value
    valueGeneration: string | null; // String with numeric value; 1 = eDGAR Generated, 2 = User Defined
    maxAttempts: number | null; // Numerical value from 0 to 255
    retryNumberLeft: number | null; // Numerical value from 0 to 255
  };
}

export interface JavaAppletsDto {
  appletId: number | null; // Primary key of the applet in the Java Applets table
  requiresDedicatedFile: string | null; // String with numeric value; 1 = Yes, 0 = No
  dedicatedFiles: JavaAppletDedicatedFileParametersDto[] | null; // See JavaAppletDedicatedFileParametersDto
  requiresElementaryFile: string | null; // String with numeric value; 1 = Yes, 0 = No
  elementaryFiles: JavaAppletElementaryFileParametersDto[] | null; // See JavaAppletElementaryFileParametersDto
}

export interface JavaAppletDedicatedFileParametersDto {
  id: number; // Used by the GUI to generate a unique key per record
  fileName: string | null; // A string value with a maximum length of 20 characters
  fileId: string | null; // 2 byte hex value
  accessRules: {
    // Value property of the following DropDownDto is a number; 1 = ALWAYS, 2 = NEVER; 3 = PIN1; 4 = ADM1
    deleteSelf: DropDownDto | null;
    terminate: DropDownDto | null;
    activate: DropDownDto | null;
    deactivate: DropDownDto | null;
    createDF: DropDownDto | null;
    createEF: DropDownDto | null;
  };
  pinStatus: {
    pin1: boolean;
    adm1: boolean;
    pin2: boolean;
  };
  locationOfFile: DropDownDto | null; // Value property of DropDownDto is a number; 1 = MF; 2 = USIM; 3 = ISIM; 4 = DF location (see locatedInDF)
  locatedInDF: DropDownDto | null; // If locationOfDF is 4, value property of DropDownDto is a number containing the id of the corresponding JavaAppletDedicatedFileParametersDto
}

export interface JavaAppletElementaryFileParametersDto {
  id: number; // Used by the GUI to generate a unique key per record
  fileName: string | null; // A string value with a maximum length of 20 characters
  fileId: string | null; // 2 byte hex value
  fileStructure: string | null; // String with numeric value; 1 = Transparent, 2 = Linear Fixed, 3 = Cyclic
  fileSize: number | null; // Integer value >= 1 and no max
  recordLength: number | null; // Integer value >= 1 and <= 65535
  accessRules: {
    // Value property of the following DropDownDto is a number; 1 = ALWAYS, 2 = NEVER; 3 = PIN1; 4 = ADM1; 5 = PIN2
    ruleNumber: DropDownDto | null; // GUI only value showing the predefined rule set being used (1 to 14)
    read: DropDownDto | null;
    update: DropDownDto | null;
    increase: DropDownDto | null;
    activate: DropDownDto | null;
    deactivate: DropDownDto | null;
    delete: DropDownDto | null;
  };
  highUpdateActivity: string | null; // String with numeric value; 1 = Yes, 2 = No
  fileContent: FileContentDto[] | null; // An array of strings, quantity is fileSize/recordLength
  locationOfFile: DropDownDto | null; // Value property of DropDownDto is a number; 1 = MF; 2 = USIM; 3 = ISIM; 4 = DF location (see locatedInDF)
  locatedInDF: DropDownDto | null; // If locationOfEF is 4, value property of DropDownDto is a number containing the id of the corresponding JavaAppletDedicatedFileParametersDto
}

export interface FileContentDto {
  content: string | null;
}

export interface DirectoryFilesDto {
  id: number; // Used by the GUI to generate a unique key per record
  applicationIdentifier: string | null; // 1 to 16 byte hex value
  label: string | null; // A string value with a maximum length of 32 characters
}

export interface NetworkNameDto {
  recordNumber: number | null; // Numerical value of the network name record number
  fullName: string | null; // A string value with a maximum length of 14 characters
}

export interface PLMNInformationDto {
  recordNumber: number | null; // Numerical value of the network name record number
  mobileCountryCode: string | null; // String representing 3-digit number
  mobileNetworkCode: string | null; // String representing 2 to 3-digit number
  pnnRecordId: number | null; // A value ranging from 1 to 10
}

export interface PLMNWithAcTDto {
  mobileCountryCode: string | null; // String representing 3-digit number
  mobileNetworkCode: string | null; // String representing 2 to 3-digit number
  accessTechnology: DropDownDto | null; // Value property of DropDownDto is a number; 1 = NG-RAN, 2 = E-UTRAN; 3 = E-UTRAN WB-S1, 4 = E-UTRAN NB-S1, 5 = UTRAN, 6 = GSM, 7 = EC-GSM-IOT, 8 = GSM Compact
}

export interface PLMNWithoutAcTDto {
  mobileCountryCode: string | null; // String representing 3-digit number
  mobileNetworkCode: string | null; // String representing 2 to 3-digit number
}

export interface SMSParametersDto {
  id: number; // Used by the GUI to generate a unique key per record
  name: string | null; // A string value with a max length of 10 characters
  parameterIndicators: DropDownDto[] | null; // An array of values, 0 to 5 in length; Value property of DropDownDto is a number; 1 = enable destinationAddress, 2 = enable serviceCenterAddress, 3 = enable protocolIdentifiers, 4 = enable dataCodingScheme, 5 = enable validityPeriod
  destinationAddress: string | null; // A string value with a max length of 12 characters
  serviceCenterAddress: string | null; // A string value with a max length of 12 characters
  protocolIdentifier: string | null; // 1 byte hex value
  dataCodingScheme: DropDownDto | null; // Value property of DropDownDto is a number; 1 = GSM 7bit default, 2 = 8bit data, 3 = UCS2 (16bit), 4 = GSM 7bit, 5 = 8bit data
  validityPeriod: DropDownDto | null; // Value property of DropDownDto is a number representing the TP-VP value ranging from 0 to 255
}

export interface EmergencyCallCodesDto {
  id: number; // Used by the GUI to generate a unique key per record
  callCode: string | null; // A string value of numbers with a max length of 6 digits
  serviceCategory: DropDownDto | null; // Value property of DropDownDto is a number; 0 = NOT SET, 1 = Police, 2 = Ambulance, 3 = Fire Brigade, 4 = Marine Guard, 5 = Mountain Rescue
}

export interface ECallRecordsDto {
  recordNumber: number | null; // Numerical value of the record position in USIM/EF_FDN or OPT-USIM\EF_SDN
  displayName: string | null; // A string value with a max length of 25 characters
  dialingNumber: string | null; // A string value with a max length of 20 characters
}

export interface USIMServiceTableDto {
  usimService1: boolean;
  usimService2: boolean;
  usimService3: boolean;
  usimService4: boolean;
  usimService5: boolean;
  usimService6: boolean;
  usimService7: boolean;
  usimService8: boolean;
  usimService9: boolean;
  usimService10: boolean;
  usimService11: boolean;
  usimService12: boolean;
  usimService13: boolean;
  usimService14: boolean;
  usimService15: boolean;
  usimService16: boolean;
  usimService17: boolean;
  usimService18: boolean;
  usimService19: boolean;
  usimService20: boolean;
  usimService21: boolean;
  usimService22: boolean;
  usimService23: boolean;
  usimService24: boolean;
  usimService25: boolean;
  usimService26: boolean;
  usimService27: boolean;
  usimService28: boolean;
  usimService29: boolean;
  usimService30: boolean;
  usimService31: boolean;
  usimService32: boolean;
  usimService33: boolean;
  usimService34: boolean;
  usimService35: boolean;
  usimService36: boolean;
  usimService37: boolean;
  usimService38: boolean;
  usimService39: boolean;
  usimService40: boolean;
  usimService41: boolean;
  usimService42: boolean;
  usimService43: boolean;
  usimService44: boolean;
  usimService45: boolean;
  usimService46: boolean;
  usimService47: boolean;
  usimService48: boolean;
  usimService49: boolean;
  usimService50: boolean;
  usimService51: boolean;
  usimService52: boolean;
  usimService53: boolean;
  usimService54: boolean;
  usimService55: boolean;
  usimService56: boolean;
  usimService57: boolean;
  usimService58: boolean;
  usimService59: boolean;
  usimService60: boolean;
  usimService61: boolean;
  usimService62: boolean;
  usimService63: boolean;
  usimService64: boolean;
  usimService65: boolean;
  usimService66: boolean;
  usimService67: boolean;
  usimService68: boolean;
  usimService69: boolean;
  usimService70: boolean;
  usimService71: boolean;
  usimService72: boolean;
  usimService73: boolean;
  usimService74: boolean;
  usimService75: boolean;
  usimService76: boolean;
  usimService77: boolean;
  usimService78: boolean;
  usimService79: boolean;
  usimService80: boolean;
  usimService81: boolean;
  usimService82: boolean;
  usimService83: boolean;
  usimService84: boolean;
  usimService85: boolean;
  usimService86: boolean;
  usimService87: boolean;
  usimService88: boolean;
  usimService89: boolean;
  usimService90: boolean;
  usimService91: boolean;
  usimService92: boolean;
  usimService93: boolean;
  usimService94: boolean;
  usimService95: boolean;
  usimService96: boolean;
  usimService97: boolean;
  usimService98: boolean;
  usimService99: boolean;
  usimService100: boolean;
  usimService101: boolean;
  usimService102: boolean;
  usimService103: boolean;
  usimService104: boolean;
  usimService105: boolean;
  usimService106: boolean;
  usimService107: boolean;
  usimService108: boolean;
  usimService109: boolean;
  usimService110: boolean;
  usimService111: boolean;
  usimService112: boolean;
  usimService113: boolean;
  usimService114: boolean;
  usimService115: boolean;
  usimService116: boolean;
  usimService117: boolean;
  usimService118: boolean;
  usimService119: boolean;
  usimService120: boolean;
  usimService121: boolean;
  usimService122: boolean;
  usimService123: boolean;
  usimService124: boolean;
  usimService125: boolean;
  usimService126: boolean;
  usimService127: boolean;
  usimService128: boolean;
  usimService129: boolean;
  usimService130: boolean;
  usimService131: boolean;
}

export interface ISIMServiceTableDto {
  isimService1: boolean;
  isimService2: boolean;
  isimService3: boolean;
  isimService4: boolean;
  isimService5: boolean;
  isimService6: boolean;
  isimService7: boolean;
  isimService8: boolean;
  isimService9: boolean;
  isimService10: boolean;
  isimService11: boolean;
  isimService12: boolean;
  isimService13: boolean;
  isimService14: boolean;
  isimService15: boolean;
  isimService16: boolean;
  isimService17: boolean;
  isimService18: boolean;
  isimService19: boolean;
  isimService20: boolean;
  isimService21: boolean;
}
